import * as PIXI from 'pixi.js';
import { v4 as uuidv4 } from 'uuid';
import { ObjectPool } from '~/Tools';
import ApplicationStore from '~/flux/stores/ApplicationStore';

let _trail;
let _trailPool;
ApplicationStore.once(ApplicationStore.ASSETS_LOADED, () => {
  _trailPool = new ObjectPool(
    // create func
    () => {
      _trail = new PIXI.BitmapText('.', {
        fontName: 'BitmapCourierBold',
        fontSize: 24,
        tint: 0x4f0d53,
      });
      _trail.alpha = 0.8;
      _trail.anchor.x = _trail.anchor.y = 0.5;
      return _trail;
    },

    // reset func
    (trail) => {
      trail.parent?.removeChild(trail);
      TweenMax.killTweensOf(trail);
      trail.alpha = 0.8;
    },

    // starting num
    100
  );
});

const instances = {};

const HasOptionRendering = {
  render: function (condition, gameBoard, isCaverns) {
    if (instances[condition.uid]) {
      return;
    }

    instances[condition.uid] = {
      isCaverns,
      trails: {},
      killTrail: (deadTrail) => {
        if (deadTrail) {
          _trailPool.put(deadTrail);
          delete instances[condition.uid].trails[deadTrail.uid];
        }
      },
    };
    const ownerSprite = (instances[condition.uid].ownerSprite =
      gameBoard.getAllPieceSprites()[condition.ownerId]);
    const parentToOrbit = (instances[condition.uid].parentToOrbit = isCaverns
      ? ownerSprite
      : ownerSprite.puppet);

    var image = (instances[condition.uid].optionImage = new PIXI.BitmapText('.', {
      fontName: 'BitmapCourierBoldDropshadow',
      fontSize: 24,
    }));
    image.anchor.x = image.anchor.y = 0.5;
    image.y = -50;

    const makeTrail = () => {
      const trail = _trailPool.get();
      trail.uid = uuidv4();
      trail.x = image.x;
      trail.y = image.y;
      TweenMax.to(trail, 0.3 + Math.random() * 0.3, {
        alpha: 0,
        onComplete: instances[condition.uid].killTrail,
        onCompleteParams: [trail],
      });
      image.parent.addChildAt(trail, image.parent.getChildIndex(image));

      instances[condition.uid].trails[trail.uid] = trail;
    };

    var tween;
    var front = false;
    const makeTween = () => {
      if (instances[condition.uid].imgTween) {
        instances[condition.uid].imgTween.kill();
      }

      const parentToOrbit = instances[condition.uid].parentToOrbit;
      if (front) {
        parentToOrbit.addChild(image);
      } else {
        parentToOrbit.addChildAt(image, 0);
      }
      front = !front;

      tween = instances[condition.uid].imgTween = TweenMax.to(image, 1.1 + Math.random() * 0.2, {
        x: image.x > 0 ? -15 - Math.random() * 7 : 15 + Math.random() * 7,
        y: isCaverns ? -20 + Math.random() * 20 : -45 + Math.random() * 35,
        ease: Quad.easeInOut,
        onUpdate: () => Math.random() < 0.5 && makeTrail(),
        onComplete: makeTween,
      });
    };
    makeTween();
  },

  stopRendering: function (conditionId) {
    if (instances[conditionId]) {
      if (instances[conditionId].imgTween) {
        instances[conditionId].imgTween.kill();
      }

      for (const trail of Object.values(instances[conditionId].trails)) {
        trail && instances[conditionId].killTrail(trail);
      }

      DT_CANVAS_GLOBALS.poolSafeDestroy(instances[conditionId].optionImage, { children: true });

      delete instances[conditionId];
    }
  },

  dispose: function () {
    for (const prop in instances) {
      HasOptionRendering.stopRendering(prop);
    }
  },
};
export default HasOptionRendering;
